
import Button from "./Button";

function OperatorCard({ operator, financial, onEdit, onDelete, onPayments }) {
  return (
    <div className="cc-operator-row">
      <div className="cc-client-main">
        <div className="cc-client-avatar cc-avatar-orange">{(operator.nombre || "?").slice(0,1).toUpperCase()}</div>
        <div>
          <strong className="cc-client-name">{operator.nombre} {operator.apellido}</strong>
          <div className="cc-client-meta">{operator.email || "Sin email"} · {operator.telefono || "Sin teléfono"}</div>
          {(operator.cbuCvu || operator.alias) && <div className="cc-client-meta cc-operator-transfer">{operator.cbuCvu ? `CBU/CVU: ${operator.cbuCvu}` : ""}{operator.cbuCvu && operator.alias ? " · " : ""}{operator.alias ? `Alias: ${operator.alias}` : ""}</div>}
        </div>
      </div>
      <div className="cc-client-stat"><span className="cc-list-label">Comisión</span><strong>{operator.comision}%</strong></div>
      <div className="cc-client-stat"><span className="cc-list-label">Estado</span><span className={`cc-badge ${operator.activo ? "cc-op-active" : "cc-op-inactive"}`}>{operator.activo ? "ACTIVO" : "INACTIVO"}</span></div>
      <div className="cc-row-actions">
        <Button variant="secondary" onClick={() => onPayments(operator)}>Pagos{financial?.pendiente > 0 ? " · pendiente" : ""}</Button>
        <Button variant="secondary" onClick={()=>onEdit(operator)}>Editar</Button>
        <Button variant="danger" onClick={()=>onDelete(operator)}>Eliminar</Button>
      </div>
    </div>
  );
}
export default OperatorCard;
